export default {
    ROLES_RECOMMENDS(state, value) {
        state.rolesRecommends = value
    },
    PAGES_RECOMMENDS(state, value) {
        state.pagesRecommends = value
    },
}